import axios from "@/api/axios";
import qs from "qs";

const roomList = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    roomlistcnt: null,
    roomlist: [
      {
        no: null,
        roomno: null,
        roomname: null,
        holetype: null,
        coursename: null,
        playercnt: null,
        starttime: null,
        endtime: null,
        playhole: null,
        status: null,
        gameno: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/room/roomlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
    params: {
      pageno: param.pageno,
    },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(finalData);
    } else {
      result(null);
    }
  });
};
const roomInfo = async (roomno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    roominfo: [
      {
        no: null,
        roomno: null,
        roomname: null,
        holetype: null,
        coursename: null,
        playercnt: null,
        starttime: null,
        endtime: null,
        playhole: null,
        status: null,
        gameno: null,
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/room/roominfo/" + roomno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // data: qs.stringify({})
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data.roominfo;
      result(finalData);
    } else {
      result(null);
    }
  });
};

const roomSave = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/room/roomwrite/",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify({
      roomno: params.roomno,
      roomname: params.roomname,
    }),
    // params: {o}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};
const roomStatusChange = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "PUT",
    url: "/postact/roomchangestatus/" + params.roomno + "/" + params.status,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // params: {o}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, null);
    }
  });
};

const roomMsgInsert = async (roomno, message, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/room/roommessage",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify({
      roomno: roomno,
      message: message,
    }),
    // params: {o}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const roomStop = async (roomno, gameno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "PUT",
    url: "/postact/roomstop/" + gameno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify()
    params: {
      roomno: roomno,
      gameno: gameno,
    },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

export default {
  roomList,
  roomInfo,
  roomSave,
  roomStatusChange,
  roomMsgInsert,
  roomStop,
};
